import { connect } from 'react-redux';
import { withAnalytics } from 'analytics';
import { loadStation, stop } from 'actions/player-actions';
import { setUserHDPreference } from 'actions/gigya-actions';
import { getIsCurrentStationPlaying } from 'store/reducers/player';
import { getUserPrefersHDSources, getIsLoggedIn } from 'store/reducers/user';
import CONTENT_TYPES from 'globalConst/contentTypes-const';
import CallToAction from './CallToAction';

const mapStateToProps = (state, ownProps) => {
  const prefersHD = getUserPrefersHDSources(state);
  const isUserLoggedIn = getIsLoggedIn(state);

  return {
    isPlaying:
      getIsCurrentStationPlaying(state, {
        station: { slug: ownProps.playStationSlug },
      }) &&
      ((ownProps.preferHD === prefersHD && isUserLoggedIn) || !ownProps.preferHD),
  };
};

const loadStationWithAnalytics = withAnalytics(loadStation, {
  player_name: CONTENT_TYPES.CALL_TO_ACTION_BLOCK,
  link_id: CONTENT_TYPES.CALL_TO_ACTION_BLOCK,
});

const stopStationWithAnalytics = withAnalytics(stop, {
  player_name: CONTENT_TYPES.CALL_TO_ACTION_BLOCK,
  link_id: CONTENT_TYPES.CALL_TO_ACTION_BLOCK,
});

const mapDispatchToProps = {
  onLoad: loadStationWithAnalytics,
  onStop: stopStationWithAnalytics,
  onSetPrefersHDSources: setUserHDPreference,
};

export default connect(mapStateToProps, mapDispatchToProps)(CallToAction);
